import { usePagination } from "../contexts/PaginationContext";

export const useRowsPerPage = () => {
  return usePagination();
};

